module.exports = __webpack_public_path__ + "img/51626531_S.aea1aaab.png";